// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-subtitle {
  overflow-x: hidden;
  height: 90%;
  overflow-y: auto;
}
.list-subtitle::-webkit-scrollbar {
  display: none;
}
.list-scene {
  overflow-x: hidden;
  max-height: 80%;
  overflow-y: auto;
}
.list-scene::-webkit-scrollbar {
  display: none;
}
.card-subtitle {
  background-color: #7c82bb;
  margin-top: 10px;
  min-height: 40px;
  border-radius: 5px;
}
.card-subtitle-select {
  background-color: #b592d5;
  margin-top: 10px;
  min-height: 40px;
  border-radius: 5px;
}
.tab-scenario .ant-tabs-tab-active {
  background: #1677ff !important;
  color: white !important;
}
.tab-scenario .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: white !important;
}
.ant-tabs-tab {
  background: white !important;
}
.tab-scenario .ant-tabs-nav {
  margin: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/videos2/VideoDetail/style/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AACF;AAEA;EACE,aAAA;AAAF;AAGA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AADF;AAIA;EACE,aAAA;AAFF;AAMA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAJF;AAOA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AALF;AAQA;EACE,8BAAA;EACA,uBAAA;AANF;AAQA;EACE,uBAAA;AANF;AASA;EACE,4BAAA;AAPF;AAUA;EACE,oBAAA;AARF","sourcesContent":[".list-subtitle {\n  overflow-x: hidden;\n  height: 90%;\n  overflow-y: auto;\n}\n\n.list-subtitle::-webkit-scrollbar {\n  display: none;\n}\n\n.list-scene {\n  overflow-x: hidden;\n  max-height: 80%;\n  overflow-y: auto;\n}\n\n.list-scene::-webkit-scrollbar {\n  display: none;\n}\n\n//subtitle\n.card-subtitle {\n  background-color: #7c82bb;\n  margin-top: 10px;\n  min-height: 40px;\n  border-radius: 5px;\n}\n\n.card-subtitle-select {\n  background-color: #b592d5;\n  margin-top: 10px;\n  min-height: 40px;\n  border-radius: 5px;\n}\n\n.tab-scenario .ant-tabs-tab-active {\n  background: #1677ff !important;\n  color: white !important;\n}\n.tab-scenario .ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: white !important;\n}\n\n.ant-tabs-tab {\n  background: white !important;\n}\n\n.tab-scenario .ant-tabs-nav {\n  margin: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
